import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import images from "../../assets/images/constantImages";
import { Link } from "react-router-dom";
import { PacmanLoader } from "react-spinners";

const Scanner = () => {
  const { id } = useParams();
  const { data: stores, loading } = useSelector((state) => state.store);
  const selectedStore = stores.find((store) => store.vendor_id === Number(id));

  const handleClick = () => {
    if (selectedStore?.canteen_user) {
      localStorage.setItem("canteen_user_id", selectedStore.canteen_user);
    }
  };

  const menuLink = selectedStore?.canteen_user
    ? `https://headquater-cms.pixoatic.com/menus/${selectedStore.canteen_user}`
    : null;

  if (loading) return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
      <PacmanLoader color="#85bd3a" size={40} />
    </div>
  );
  return (
    <div className="relative flex items-center justify-center">
      <img src={images.foodbgimage} alt="" className="h-screen w-full object-cover" />

      <div className="text-center max-w-xl absolute">
        {selectedStore?.store_logo && (
          <img
            src={selectedStore.store_logo}
            alt="Store logo"
            className="mx-auto w-44 h-14"
          />
        )}
        <h1 className="text-2xl font-bold text-black mt-3 mb-2">
          DIGITAL FOOD MENU
        </h1>

        {selectedStore?.qr ? (
          <>
            <Link to={`/menus/${selectedStore.canteen_user}`} onClick={handleClick}>
              <div className="inline-block rounded-lg cursor-pointer">
                <img
                  src={selectedStore.qr}
                  alt="QR Code"
                  className="w-[300px] h-[300px]"
                  title="Click to scan"
                />
              </div>
            </Link>

          
            <p className="text-black mt-4 font-medium">
              Menu Link:
              <a
                href={menuLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
                onClick={handleClick}
              >
                {menuLink}
              </a>
            </p>
          </>
        ) : (
          <p className="text-lg text-red font-semibold mt-4">
            QR code not available for this store.
          </p>
        )}

      </div>
    </div>
  );
};

export default Scanner;
